<script>
/* eslint-disable vue/no-v-html */
import FcmDate from "@components/diversos/FcmDate";
import * as FcmOnCall from "@src/services/FcmOnCall";
import {appConfig} from '@src/config';
import JsonViewer from 'vue-json-viewer';
const Emitter = require('tiny-emitter');
const emitter = new Emitter();
import status from "@common/status";
import FcmTimer from "@components/diversos/FcmTime";

import cloneDeep from "lodash/cloneDeep";

FcmOnCall.setConfig(appConfig);

// https://sistema.volan.app.br/response/volan/qaAnestesia?isDark=1&responseId=2FYtz6KOx59Q57ooxKBLNo
// https://sistema.volan.app.br/response/[companyId]/[slug]?isDark=1&responseId=[responseId]


if (window?.webkit?.messageHandlers?.formActionsHandler) {
  window.webkit.messageHandlers.formActionsHandler.postMessage({
    action: 'debug',
    data: 'jsLoading',
  });
}

function parseQuery(queryString) {
  let query = {};
  let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}

window.jwFormDataLoaded = (args) => {
  emitter.emit('sendDataToJs', args);
};

export default {
  components: {FcmTimer, FcmDate, JsonViewer},
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Object,
      default: ()=>null,
    },
  },
  data(vm) {
    return {
      form: {},
      valueId: null,
      tryingToUpdate: false,
      connectionError: false,
      FormInputType: status.FormInputType,
      FormLinkType: status.FormLinkType,
      response: {},
      rules: {
        ...vm.$validateRules(),
      },
      responseSend: false,
      isLoading: true,
      extraData: {},
      links: null,
      isNew: false,
      userAuth: {},
      hasDataLoad: false,
      promiseDataLoad: null,
      promiseDataLoadResolve: null,
      isDebug: false,
      formCompanyId: '',
      slug: '',
      versionNumber: process.env.VUE_APP_VERSION_NUMBER,
      version: process.env.VUE_APP_VERSION,
      query: {},
      info: {},
      logoUrl: null,
      extraDataMobile: {},
      errorMessage: '',
      timeOver: false,
      debugList: [],
      trustedParentOrigin: null,
    }
  },
  computed: {
    canEdit() {
      return this.isNew || this.form?.canEditResponse;
    }
  },
  watch: {
    info(value, oldValue) {
      if(value!==oldValue) {

        this.$emit('changeCompanyInfo', {
          images: value?.data?.info?.companyImages || null,
          name: value?.data?.extraData?.companyName || null,
          id: value?.data?.extraData?.formCompanyId || null,
        });
      }
    },
    isLoading(value, oldValue) {
      if(value!==oldValue && !value) {
        this.$emit('finishLoading');
      }
    }
  },
  created() {
    // Cria promise para aguardar dados
    this.promiseDataLoad = new Promise((resolve) => {
      this.promiseDataLoadResolve = resolve;
    });

    // Listener para receber dados do volan_admin via postMessage (cross-origin)
    window.addEventListener('message', (event) => {
      if (event.data?.type === 'VOLAN_FORM_DATA') {
        // this.logGroup('[FORMS] Dados recebidos', '#9C27B0', () => {
        //   console.log('userId:', event.data.payload.info?.userId);
        //   console.log('companyId:', event.data.payload.info?.companyId);
        //   console.log('eventId:', event.data.payload.info?.eventId);
        // });

        // Guarda origin confiável para usar nas respostas
        this.trustedParentOrigin = event.origin;

        // Seta window.jwFormData para manter compatibilidade com mobile
        window.jwFormData = event.data.payload;

        // Processa dados (preenche extraData, userAuth, etc)
        this.processData(event.data.payload);

        // Resume loadForm() se estiver aguardando
        if (this.promiseDataLoadResolve) {
          this.promiseDataLoadResolve();
          this.promiseDataLoadResolve = null;
        }
      }
    });
  },
  async mounted() {
    let params = window.location.pathname.split('/').filter((a)=>a);
    this.formCompanyId = params?.[1] || '';
    this.slug = params?.[2] || '';

    this.query = parseQuery(window.location.search);
    if(this.query.hasDataLoad) {
      this.hasDataLoad = JSON.parse(this.query.hasDataLoad) || false;
    }
    this.valueId = this.query?.responseId || null;
    this.emitToMobile('debug', 'mounted');

    // HANDSHAKE: Avisa volan_admin que está pronto para receber dados via postMessage
    if(window.parent && window.parent !== window) {
      // this.logGroup('[FORMS] Handshake enviado', '#FF9800', () => {
      //   console.log('Aguardando dados via postMessage');
      // });

      window.parent.postMessage({
        type: 'VOLAN_FORM_READY'
      }, '*');
    }
    // if(this.$route.query.responseId) {
    //   this.valueId = this.$route.query?.responseId || null;
    // }
    // if(this.$route.query.hasDataLoad) {
    //   this.hasDataLoad = JSON.parse(this.$route.query?.hasDataLoad) || false;
    // }
    // if(this.$route.query.isDebug) {
    //   this.isDebug = JSON.parse(this.$route.query?.isDebug) || false;
    // }
    emitter.on('sendDataToJs', (args) => {
      this.emitToMobile('debug', 'receivedData: '+this.isDebug?JSON.stringify(args):'No debug');
      this.processData(args);
      this.promiseDataLoadResolve?.();
      this.promiseDataLoadResolve = null;
    });

    if(window.jwFormData) {
      this.processData(window.jwFormData);
      this.promiseDataLoadResolve?.();
      this.promiseDataLoadResolve = null;
    }

    await this.loadForm();
  },
  destroyed() {
    emitter.off('sendDataToJs');
  },
  methods: {
    // Log centralizado e agrupado (descomentar para debug)
    logGroup(title, color, callback) {
      console.group(`%c${title}`, `color: ${color}; font-weight: bold;`);
      callback();
      console.groupEnd();
    },

    tryApplyExtraDataItem(response, data) {
      // this.logGroup('[FORMS] Preenchendo campo', '#8BC34A', () => {
      //   console.log('Tipo:', response.type);
      //   console.log('Valor atual:', response.responseText || response.responseDate || response.responseDateTime || response.responseTime || '(vazio)');
      //   console.log('Valor novo:', data);
      // });

      if(!data) return;

      if((response.type===this.FormInputType.text || response.type===this.FormInputType.paragraph) && !response.responseText) {
        let testDate = moment(data);
        if(testDate.isValid() && typeof data === 'string' && data.match(/^\d{4}-\d{2}-\d{2}T/)) {
          response.responseText = testDate.format('DD/MM/YYYY');
        }
        else {
          response.responseText = data;
        }
      }
      else if(response.type===this.FormInputType.date && !response.responseDate) {
        response.responseDate = data;
      }
      else if(response.type===this.FormInputType.dateTime && !response.responseDateTime) {
        response.responseDateTime = data;
      }
      else if(response.type===this.FormInputType.time && !response.responseTime) {
        let testDate = moment(data);
        if(testDate.isValid()) {
          response.responseTime = testDate.format('HH:mm');
        }
        else {
          response.responseTime = data;
        }
      }
    },
    debug(name, info) {
      if (this.query.debugOnScreen) {
        this.debugList.push({
          name,
          info
        });
      }
    },
    processData(args) {
      this.debug('processData', args);

      // this.logGroup('[FORMS] Processando dados recebidos', '#00BCD4', () => {
      //   console.log('userAuth:', this.userAuth);
      //   console.log('extraDataMobile:', this.extraDataMobile);
      // });

      this.userAuth = args.userAuth || {};
      this.extraDataMobile = args.info || {};
      // this.extraData = args.info || {};
      // if(this.links) {
      //   for(const index in this.extraData) {
      //     for(const local of this.links[index] || []) {
      //       if(this.response?.sections?.[local.sectionId]?.items?.[local.itemId]) {
      //         this.tryApplyExtraDataItem(this.response.sections[local.sectionId].items[local.itemId],
      //             this.extraData[index]);
      //         // if(!this.response.sections[local.sectionId].items[local.itemId].responseText) {
      //         //   this.response.sections[local.sectionId].items[local.itemId].responseText = this.extraData[index];
      //         // }
      //       }
      //     }
      //   }
      // }
      // this.response.extraData = this.response.extraData || {};
      // for(const i in this.extraData) {
      //   if(typeof this.extraData[i]==='string' && !this.response.extraData[i]) {
      //     this.response.extraData[i] = this.extraData[i];
      //   }
      // }

      this.response.userLoggedId = this.extraDataMobile['userId'] || this.response.userLoggedId || this.extraData['userId'] || '';
      this.response.userLoggedName = this.extraDataMobile['userName'] || this.response.userLoggedName || this.extraData['userName'] || '';
      this.response.userLoggedCompanyId = this.extraDataMobile['companyId'] || this.response.userLoggedCompanyId || this.extraData['companyId'] || '';
      this.response.companyId = this.response.userLoggedCompanyId;

      FcmOnCall.setAuth(args.userAuth);
    },
    async loadForm() {
      this.debug('loadForm');
      this.isLoading = true;
      this.connectionError = false;
      this.errorMessage = '';
      this.timeOver = false;
      let form = {};
      let response = {
        active: true,
        sections: {},
        formId: '',
        companyId: '',
        formCompanyId: '',
        slug: '',
      };

      if(this.hasDataLoad) {
        this.debug('Esperando hasDataLoad');
        await this.promiseDataLoad;
      }

      const getInfoParams = {
        ...this.extraDataMobile,
        ...this.query,
        slug: this.slug,
        formCompanyId: this.formCompanyId
      };

      this.debug('getInfo', getInfoParams);

      // this.logGroup('[FORMS] Chamando Cloud Function', '#673AB7', () => {
      //   console.log('Slug:', this.slug);
      //   console.log('Params:', getInfoParams);
      // });

      this.info = await FcmOnCall.callOnCall('forms-getInfo', getInfoParams);

      // this.logGroup('[FORMS] Cloud Function retornou', '#673AB7', () => {
      //   console.log('Form:', this.info?.data?.form?.name);
      //   console.log('extraData:', this.info?.data?.extraData);
      // });

      this.valueId = this.info?.data?.responseId || this.valueId || null;
      this.logoUrl = this.info?.data?.info?.companyImagesLogo?.url || null;

      let responseData = this.info?.data?.response || null;

      // this.logGroup('[FORMS] Merge extraData', '#E91E63', () => {
      //   console.log('extraDataMobile:', this.extraDataMobile);
      //   console.log('extraData Cloud:', this.info?.data?.extraData);
      // });

      this.extraData = {...this.extraDataMobile, ...this.info?.data?.extraData};

      this.isNew = !responseData;
      if(this.info?.status===490) {
        this.errorMessage = this.$t('formInput.formNotFound');
        this.connectionError = true;
        this.isLoading = false;
        this.$showError({title: this.$t('formInput.errorConnection')});
        return;
      }
      if(this.info?.data?.errorCode===status.apiErrorCode.warningAnswered) {
        this.errorMessage = this.$t('formInput.responseSendPrevious');
      }
      else if(this.info?.data?.errorCode===status.apiErrorCode.OK) {
        if(this.info?.data?.info?.timeOver) {
          this.timeOver = true;
          this.errorMessage = this.$t('formInput.errorTimeOver');
        }
        form = this.info?.data?.form || null;
        this.links = {};

        // this.logGroup('[FORMS] Montando formulário', '#FF5722', () => {
        //   console.log('Form:', form?.name);
        //   console.log('Seções:', form?.sections?.length || 0);
        // });

        for(const section of form?.sections || {}) {
          response.sections[section.id] = {
            items: {},
           // name: section.name,
          };

          let camposVinculados = 0;

          for(const item of section.items) {
            response.sections[section.id].items[item.id] = {
              type: item.type,
              responseText: '',
              responseOption: null,
              responseOptions: {},
              ...responseData?.sections?.[section.id]?.items?.[item.id],
              // question: item,
            };

            if(item.link && item.link!==this.FormLinkType.none) {
              this.links[item.link] = this.links[item.link] || [];
              this.links[item.link].push({sectionId: section.id, itemId: item.id});

              // this.logGroup(`[FORMS] Vinculando "${item.name}"`, '#FF5722', () => {
              //   console.log('Link:', item.link);
              //   console.log('Valor:', this.extraData[item.link]);
              //   console.log('Tipo:', item.type);
              // });

              this.tryApplyExtraDataItem(response.sections[section.id].items[item.id], this.extraData[item.link]);
              camposVinculados++;
            }
          }
        }

        // this.logGroup('[FORMS] Vínculos registrados', '#FF5722', () => {
        //   console.log('Total:', Object.keys(this.links).length);
        //   console.log('Mapa:', this.links);
        // });
      }
      else {
        this.errorMessage = this.$t('formInput.formNotFound');
        form = {};
      }
      response.formId = form.id || '';
      response.formCompanyId = form.companyId || '';
      response.slug = form.slug || '';
      response.categorySlug = form.categorySlug || '';
      response.version = form.version || 0;
      response.isSuperAdmin = form.isSuperAdmin || false;
      response.extraData = response.extraData || {};
      for(const i in this.extraData) {
        if(typeof this.extraData[i]==='string' && !response.extraData[i]) {
          response.extraData[i] = this.extraData[i];
        }
      }
      response.userLoggedId = this.extraDataMobile['userId'] || response.userLoggedId || this.extraData['userId'] || '';
      response.userLoggedName = this.extraDataMobile['userName'] || response.userLoggedName || this.extraData['userName'] || '';
      response.userLoggedCompanyId = this.extraDataMobile['companyId'] || response.userLoggedCompanyId ||
          this.extraData['companyId'] || response.formCompanyId || '';
      response.companyId = response.userLoggedCompanyId;
      this.response = response;
      this.form = form;
      this.isLoading = false;
      this.emitToMobile('debug', 'formLoaded');
    },
    goBack() {
     // this.$emit('input', null);
    },
    async submitResponse() {
      if (this.$refs.form && !this.$refs.form.validate()) {
        this.$showError({title: this.$t('formInput.errorValidate')});
        return;
      }
      let response = cloneDeep(this.response);
      response.id = this.valueId || null;
      this.tryingToUpdate = true;

      for(const section of this.form.sections) {
        for (const item of section.items) {
          if(response.sections[section.id].items[item.id].responseNumber) {
            response.sections[section.id].items[item.id].responseNumber = parseFloat(response.sections[section.id].items[item.id].responseNumber);
          }
          else if(response.sections[section.id].items[item.id].responseNumber===0) {}
          else {
            response.sections[section.id].items[item.id].responseNumber = null;
            this.emitToMobile('debug', 'response nullable');
          }
        }
      }

      if(this.hasDataLoad) {
        await this.promiseDataLoad;
      }
      try {
        let data = {response};
        if(this.query.fcmDebug) {
          data.fcmDebug = true;
        }
        let ret = await FcmOnCall.callOnCall('forms-setResponse', data);
        if(ret.status===200 && ret.data?.errorCode===status.apiErrorCode.OK) {
          this.$showSuccess();
          this.responseSend = true;
          this.valueId = ret.data?.data?.id;
          this.emitToMobile('success', this.valueId);
        }
        else if(ret.status===200 && ret.data?.errorCode===status.apiErrorCode.timeOver) {
          console.error('Erro Tempo permitido para resposta excedido');
          this.$showError({title: this.$t('formInput.errorTimeOver')});
          this.emitToMobile('error', 'Erro Tempo permitido para resposta excedido');
        }
        else if(ret.status===200 && ret.data?.errorCode===status.apiErrorCode.permissionDenied) {
          console.error('errorPermissionDenied');
          this.$showError({title: this.$t('formInput.errorPermissionDenied')});
          this.emitToMobile('error', 'errorPermissionDenied');
        }
        else {
          if(ret.status===490) {
            this.$showError({title: this.$t('formInput.errorConnection')});
            return;
          }
          else {
            console.error('Erro ao gravar resposta com onCall', ret);
            this.$showError({title: this.$t('formInput.errorOnWriteCall')});
            this.emitToMobile('error', 'Erro ao gravar com onCall: '+JSON.stringify(ret));
          }
        }
      } catch(err) {
        console.error('Erro ao gravar resposta', err);
        this.$showError({title: this.$t('formInput.errorOnSave')});
        this.emitToMobile('error', 'Erro ao salvar dados: '+(err?.message || ''));
      }
      this.tryingToUpdate = false;
    },
    async cancel() {
      this.emitToMobile('cancel');
    },
    async testando() {
      this.isLoading = true;
      const formObjs = await FcmOnCall.callOnCall('forms-getForm', {slug: this.slug, companyId: this.companyId});
      this.isLoading = false;
    },
    emitToMobile(action, data) {
      // iOS
      if (window?.webkit?.messageHandlers?.formActionsHandler) {
        window.webkit.messageHandlers.formActionsHandler.postMessage({
          action,
          data: data || '',
        });
      }

      // Android
      if(typeof androidInterface==='object' && typeof androidInterface?.onStatusChanged==='function') {
        androidInterface.onStatusChanged(action, data||'');
      }

      // Web (iframe) - envia postMessage para parent window
      if (window.parent && window.parent !== window) {
        const messageType = {
          'success': 'VOLAN_FORM_SUCCESS',
          'cancel': 'VOLAN_FORM_CANCEL',
          'error': 'VOLAN_FORM_ERROR'
        }[action];

        if (messageType) {
          // SEGURANÇA: Usa origin confiável se disponível, senão '*' (fallback)
          const targetOrigin = this.trustedParentOrigin || '*';

          window.parent.postMessage({
            type: messageType,
            payload: data
          }, targetOrigin);
        }
      }
    },
    changeOptions(sectionId, itemId) {
      let item = this.response.sections[sectionId].items[itemId];
      if(item.responseOption!=='other' && item.responseText) {
        this.$set(this.response.sections[sectionId].items[itemId], 'responseText', '');
      }
    },
    changeOptionsCheckbox(sectionId, itemId) {
      let item = this.response.sections[sectionId].items[itemId];
      if(!item.responseOption?.other && item.responseText) {
        this.$set(this.response.sections[sectionId].items[itemId], 'responseText', '');
      }
    },
    checkboxRequired(options) {
      for(const i in options) {
        if(options[i]) {
          return true;
        }
      }
      return false;
    },
  }
}
</script>

<template>
  <div class="box mb-10 formResponse">
    <div v-if="isLoading || tryingToUpdate" class="content loading">
      <VProgressCircular indeterminate color="primary" :size="70" :width="7"></VProgressCircular>
    </div>
    <div v-else-if="connectionError" class="content mainMessage">
      <VIcon class="messageIcon" color="error" large>mdi-alert-circle</VIcon>
      <div class="messageText">
        {{$t('formInput.errorConnection')}} <br>
        <VBtn class="mr-2 mt-2" @click="loadForm"><VIcon class="mr-2">mdi-refresh</VIcon>{{$t('formInput.tryLoadFormAgain')}}</VBtn>
      </div>
    </div>
    <div v-else-if="errorMessage && (!timeOver && isNew)" class="content mainMessage">
      <VIcon class="messageIcon" color="info" large>mdi-information</VIcon>
      <div class="messageText">{{errorMessage}}</div>
    </div>
    <div v-else-if="responseSend" class="content mainMessage">
      <VIcon class="messageIcon" color="success" large>mdi-check-circle</VIcon>
      <div class="messageText">{{$t('formInput.responseSend')}}</div>
    </div>
    <div v-else class="content">
      <div v-if="canEdit && timeOver" class="mainMessage timeOverMessage">
        <VIcon class="messageIcon" color="warning" large>mdi-alert</VIcon>
        <div class="messageText">{{errorMessage}}</div>
      </div>
<!--      <VBtn text class="pl-1" @click.stop="goBack" >-->
<!--        <VIcon x-large left>mdi-chevron-left</VIcon>-->
<!--        {{$t('all.goBack')}}-->
<!--      </VBtn>-->
      <h3 class="header">{{$trdb(form.name)}}</h3>
      <div v-if="debugList.length">
        <div v-for="(item, index) in debugList" :key="index">
          <h3>{{item.name}}</h3>
          <JsonViewer
              v-if="item.info && typeof item.info==='object'"
              :value="item.info"
              :expand-depth="8"
              class="mt-4"
              theme="jw-json-viwer-theme"
              copyable
              :sort="true"
          />
          <div v-else-if="item.info">{{item.info}}</div>
          <hr>
        </div>
      </div>
      <br>
      <div v-if="form.body" class="body ck-content">
        <div class="bodyHeader">
          <VIcon color="info" class="bodyIcon">mdi-information-outline</VIcon>
          <span class="bodyTitle">Informações</span>
        </div>
        <div class="bodyContent" v-html="$trdb(form.body)"></div>
      </div>
      <VForm ref="form" class="sections" :disabled="!canEdit || timeOver">
        <div v-for="(section, sectionIndex) in form.sections" :key="'section_'+section.id" class="section">
          <div class="sectionContent">
            <div class="sectionHeader">
              {{section.name}}
            </div>
            <div v-for="item in form.sections[sectionIndex].items" :key="'item_'+section.id+'_'+item.id" class="questionResponses">
              <div class="questionResponse">
                <div v-if="item.type===FormInputType.text">
                  <VTextField
                      v-model="response.sections[section.id].items[item.id].responseText"
                      :label="`${item.name} ${item.mandatory?'*':''}`"
                      :rules="item.mandatory?[rules.required]:[]"
                  ></VTextField>
                </div>
                <div v-if="item.type===FormInputType.number">
                  <VTextField
                      v-model="response.sections[section.id].items[item.id].responseNumber"
                      :label="`${item.name} ${item.mandatory?'*':''}`"
                      :rules="item.mandatory?[rules.required]:[]"
                      type="number"
                  ></VTextField>
                </div>
                <div v-if="item.type===FormInputType.paragraph">
                  <VTextarea
                      v-model="response.sections[section.id].items[item.id].responseText"
                      :label="`${item.name} ${item.mandatory?'*':''}`"
                      :rules="item.mandatory?[rules.required]:[]"
                      outlined
                  ></VTextarea>
                </div>
                <div v-if="item.type===FormInputType.radio">
                  <div class="questionResponseHeader">
                    {{`${item.name} ${item.mandatory?'*':''}`}}
                  </div>
                  <VRadioGroup
                      v-model="response.sections[section.id].items[item.id].responseOption"
                      :rules="item.mandatory?[rules.required]:[]"
                      @change="changeOptions(section.id, item.id)"
                  >
                    <VRadio
                        v-for="option in item.options"
                        :key="'option_'+section.id+'_'+item.id+'_'+option.id"
                        :label="option.name"
                        :value="option.id"
                    ></VRadio>
                    <VRow v-if="item.other" align="center">
                      <VRadio
                          :label="$t('formInput.responseOther')"
                          value="other"
                          class="mr-2 ml-3"
                      ></VRadio>
                      <VTextField
                          v-model="response.sections[section.id].items[item.id].responseText"
                          class="mr-3"
                          :placeholder="$t('formInput.responseOtherTextField')"
                          :disabled="response.sections[section.id].items[item.id].responseOption!=='other'"
                      ></VTextField>
                    </VRow>
                  </VRadioGroup>
                </div>
                <div v-if="item.type===FormInputType.booleanNa">
                  <div class="questionResponseHeader">
                    {{`${item.name} ${item.mandatory?'*':''}`}}
                  </div>
                  <VRadioGroup
                      v-model="response.sections[section.id].items[item.id].responseOption"
                      :rules="item.mandatory?[rules.required]:[]"
                  >
                    <VRadio
                        v-for="option in item.options"
                        :key="'option_'+section.id+'_'+item.id+'_'+option.id"
                        :label="option.name"
                        :value="option.id"
                    ></VRadio>
                  </VRadioGroup>
                </div>
                <div v-if="item.type===FormInputType.checkbox">
                  <div class="questionResponseHeader">
                    {{`${item.name} ${item.mandatory?'*':''}`}}
                  </div>
                  <VCheckbox
                      v-for="option in item.options"
                      :key="'option_'+section.id+'_'+item.id+'_'+option.id"
                      v-model="response.sections[section.id].items[item.id].responseOptions[option.id]"
                      :label="option.name"
                      hide-details
                      :rules="item.mandatory?[checkboxRequired(response.sections[section.id].items[item.id].responseOptions)]:[]"
                  ></VCheckbox>
                  <VRow v-if="item.other" align="center" class="mt-1">
                    <VCheckbox
                        v-model="response.sections[section.id].items[item.id].responseOptions.other"
                        :label="$t('formInput.responseOther')"
                        class="mr-2 ml-3"
                        :rules="item.mandatory?[checkboxRequired(response.sections[section.id].items[item.id].responseOptions)]:[]"
                        @change="changeOptionsCheckbox(section.id, item.id)"
                    ></VCheckbox>
                    <VTextField
                        v-model="response.sections[section.id].items[item.id].responseText"
                        class="mr-3"
                        :placeholder="$t('formInput.responseOtherTextField')"
                        :disabled="!response.sections[section.id].items[item.id].responseOptions.other"
                    ></VTextField>
                  </VRow>
                </div>
                <div v-if="item.type===FormInputType.select">
                  <VSelect
                      v-model="response.sections[section.id].items[item.id].responseOption"
                      :items="item.options"
                      :label="`${item.name} ${item.mandatory?'*':''}`"
                      :rules="item.mandatory?[rules.required]:[]"
                      item-text="name"
                      item-value="id"
                  ></VSelect>
                </div>
                <div v-if="item.type===FormInputType.date">
                  <FcmDate
                      v-model="response.sections[section.id].items[item.id].responseDate"
                      :label="`${item.name} ${item.mandatory?'*':''}`"
                      :rules="item.mandatory?[rules.required]:[]"
                      type="iso"
                  ></FcmDate>
                </div>
                <div v-if="item.type===FormInputType.dateTime">
                  <FcmDate
                      v-model="response.sections[section.id].items[item.id].responseDateTime"
                      :label="`${item.name} ${item.mandatory?'*':''}`"
                      :rules="item.mandatory?[rules.required]:[]"
                      type="iso"
                      pick-time
                      format="DD/MM/YYYY HH:mm"
                      mask="##/##/#### ##:##"
                  ></FcmDate>
                </div>
                <div v-if="item.type===FormInputType.time">
                  <FcmTimer
                      v-model="response.sections[section.id].items[item.id].responseTime"
                      :label="`${item.name} ${item.mandatory?'*':''}`"
                      :rules="item.mandatory?[rules.required]:[]"
                  ></FcmTimer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VForm>
      <div class="actions">
        <VBtn color="success" large :disabled="!canEdit || tryingToUpdate" @click="submitResponse">{{$t('formInput.submitResponse')}}</VBtn>
        <VBtn color="warning" large @click="cancel">{{$t('formInput.cancel')}}</VBtn>
      </div>
    </div>
    <div class="version">
      {{version}}
    </div>

  </div>
</template>

<style lang="scss">

.formResponse {
  .v-label {
    color: var(--v-text-base)!important;
  }
  .theme--dark.v-label {
    color: var(--v-text-base)!important;
  }

  // Labels de TextField, Textarea, Select = bold
  .v-text-field, .v-textarea, .v-select {
    .v-label {
      font-size: 16px!important;
      font-weight: 600!important;

      @media screen and (max-width: 700px) {
        font-size: 15px!important;
      }

      @media screen and (max-width: 420px) {
        font-size: 14px!important;
      }
    }
  }

  // Labels de Radio e Checkbox = normal (não bold)
  .v-radio .v-label,
  .v-checkbox .v-label {
    font-size: 15px!important;
    font-weight: 400!important;

    @media screen and (max-width: 420px) {
      font-size: 14px!important;
    }
  }
}

</style>

<style lang="scss" scoped>
// @import '@design';

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.box {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  .loading {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .version {
    color: #5a5a5a;
    padding: 45px 20px 5px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    justify-self: flex-end;
    flex: 1;
  }

  .mainMessage {
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 16px;

    .messageIcon {
      margin-bottom: 8px;
    }

    .messageText {
      font-size: 16px;
      line-height: 1.6;
      max-width: 600px;
    }
  }

  .timeOverMessage {
    background: rgba(251, 140, 0, 0.08);
    border-radius: 8px;
    border: 1px solid rgba(251, 140, 0, 0.3);
    margin-bottom: 20px;
    padding: 16px 20px;
  }

  .content {
    max-width: 900px;
    width: 80%;
    animation: fadeInUp 0.6s ease-out 0.2s both;
    @media screen and (max-width: 920px) {
      width: 95%;
    }
    .header {
      margin-top: 24px;
      margin-bottom: 24px;
      font-size: 30px;
      font-weight: 700;
      letter-spacing: -0.5px;
      text-align: center;
      padding: 20px 24px;
      background: rgba(36, 183, 58, 0.05);
      border-radius: 8px;
      border: 1px solid rgba(36, 183, 58, 0.15);
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg,
          rgba(36, 183, 58, 0.8) 0%,
          rgba(36, 183, 58, 0.4) 50%,
          transparent 100%
        );
      }

      @media screen and (max-width: 700px) {
        font-size: 24px;
        padding: 16px 20px;
      }

      @media screen and (max-width: 420px) {
        font-size: 20px;
        padding: 14px 16px;
      }
    }
    .body {
      margin-bottom: 24px;
      padding: 0;
      background-color: rgba(255, 255, 255, 0.02);
      border-radius: 8px;
      overflow: hidden;
      position: relative;
      border: 1px solid rgba(33, 150, 243, 0.15);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg,
          rgba(33, 150, 243, 0.8) 0%,
          rgba(33, 150, 243, 0.4) 50%,
          transparent 100%
        );
      }

      .bodyHeader {
        padding: 14px 18px 14px 16px;
        display: flex;
        align-items: center;
        gap: 10px;
        position: relative;

        .bodyIcon {
          font-size: 22px;
          background: rgba(33, 150, 243, 0.15);
          padding: 6px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;

          @media screen and (max-width: 700px) {
            font-size: 20px;
            padding: 5px;
          }

          @media screen and (max-width: 420px) {
            font-size: 18px;
            padding: 5px;
          }
        }

        .bodyTitle {
          font-size: 15px;
          font-weight: 600;
          color: rgba(33, 150, 243, 0.9);
          letter-spacing: 0.3px;

          @media screen and (max-width: 700px) {
            font-size: 14px;
          }

          @media screen and (max-width: 420px) {
            font-size: 13px;
          }
        }

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 16px;
          right: 16px;
          height: 1px;
          background: linear-gradient(90deg,
            transparent 0%,
            rgba(33, 150, 243, 0.2) 20%,
            rgba(33, 150, 243, 0.2) 80%,
            transparent 100%
          );
        }
      }

      .bodyContent {
        padding: 16px 20px;
        font-size: 15px;
        line-height: 1.6;

        //::v-deep img {
        //  max-width: 100%;
        //  max-height: 100%;
        //}

        @media screen and (max-width: 700px) {
          padding: 14px 18px;
        }

        @media screen and (max-width: 420px) {
          padding: 12px 16px;
          font-size: 14px;
        }
      }
    }
    .sections {
      margin-top: 24px;
      .section {
        min-height: 80px;
        border-radius: 10px;
        background-color: var(--v-modalBg-base)!important;
        padding: 20px 16px;
        margin-bottom: 20px;
        border: 1px solid rgba(255, 255, 255, 0.08);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        transition: all 0.2s ease;
        animation: slideInRight 0.4s ease-out backwards;

        @for $i from 1 through 10 {
          &:nth-child(#{$i}) {
            animation-delay: #{0.1 + ($i * 0.05)}s;
          }
        }

        &:hover {
          border-color: rgba(36, 183, 58, 0.3);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
        }
        .sectionContent {
          .sectionHeader {
            font-size: 22px;
            font-weight: 700;
            margin-bottom: 16px;
            color: var(--v-text-base);
            position: relative;
            padding-left: 16px;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 6px;
              height: 28px;
              background: var(--v-primary-base);
              border-radius: 3px;
            }

            @media screen and (max-width: 700px) {
              font-size: 20px;
              padding-left: 14px;

              &::before {
                width: 5px;
                height: 24px;
              }
            }

            @media screen and (max-width: 420px) {
              font-size: 18px;
              padding-left: 12px;

              &::before {
                width: 4px;
                height: 20px;
              }
            }
          }
          .questionResponses {
            .questionResponse {
              margin: 0 0 12px;
              padding: 16px 14px;
              min-height: 30px;
              background-color: var(--v-listItemBg-base)!important;
              border-radius: 8px;

              .questionResponseHeader {
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 10px;
                color: var(--v-text-base);
                position: relative;
                padding-left: 12px;

                &::before {
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                  width: 4px;
                  height: 20px;
                  background: linear-gradient(135deg, var(--v-primary-base), var(--v-success-base));
                  border-radius: 2px;
                }

                @media screen and (max-width: 700px) {
                  font-size: 15px;
                  padding-left: 10px;

                  &::before {
                    width: 3px;
                    height: 18px;
                  }
                }

                @media screen and (max-width: 420px) {
                  font-size: 14px;
                  padding-left: 10px;

                  &::before {
                    width: 3px;
                    height: 16px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .actions {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 12px;
      margin-top: 32px;
      margin-bottom: 32px;
      flex-wrap: wrap;

      @media screen and (max-width: 600px) {
        flex-direction: column;
        gap: 16px;

        .v-btn {
          width: 100%;
          max-width: 300px;
        }
      }
    }
  }
}
</style>





















